import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export type DrivingControllerType = 'controller' | 'wheel';

export interface DrivingController {
    id?: number;
    type: DrivingControllerType;
    text: string;
}

@Injectable()
export class DrivingControllerService {
    private apiUrl = `${environment.apiBaseUrl}/api/drivingController.php`;
    private apiPrefUrl = `${environment.apiBaseUrl}/api/playerController.php`;

    constructor(private http: HttpClient) {}

    // ── Catalog (admin-managed master data) ───────────────────────────────────
    getAll(): Observable<DrivingController[]> {
        return this.http.get<DrivingController[]>(this.apiUrl);
    }

    create(controller: DrivingController): Observable<DrivingController> {
        return this.http.post<DrivingController>(this.apiUrl, controller);
    }

    update(controller: DrivingController): Observable<{ success: boolean }> {
        return this.http.put<{ success: boolean }>(this.apiUrl, controller);
    }

    remove(id: number): Observable<{ success: boolean }> {
        return this.http.delete<{ success: boolean }>(this.apiUrl, { body: { id } });
    }

    // ── Per-player preference ─────────────────────────────────────────────────
    /** Read the preference of the logged-in member (admin: another driver). */
    getPreference(user_name?: string): Observable<{ controller_id: number | null }> {
        const params = user_name ? new HttpParams().set('user_name', user_name) : undefined;
        return this.http.get<{ controller_id: number | null }>(this.apiPrefUrl, { params });
    }

    /** Set/clear the preference of the logged-in member (admin: another driver). */
    setPreference(
        controller_id: number | null,
        user_name?: string,
    ): Observable<{ controller_id: number | null }> {
        return this.http.post<{ controller_id: number | null }>(this.apiPrefUrl, {
            controller_id,
            ...(user_name ? { user_name } : {}),
        });
    }
}
